{
    "name": "Cabbage",
    "binomial_name": "Brassica oleracea",
    "common_names": [
        "cabbage",
        "headed cabbage"
    ],
    "description": "Cabbage is a member of the Brassica family and related to kale, broccoli, brussels sprouts, and cauliflower. It's dense, layered heads grow on stalks and are surrounded by looser outer leaves. It's leaves can be green, white, or purple in color, and smooth or crinkly in texture. Depending on the variety, the head can be round, oblong, or flat. Cabbage prefers cooler temperatures and is best planted in the spring or fall.",
    "sun_requirements": "Full Sun",
    "sowing_method": "Direct seed indoors, transplant seedlings outside after hardening off.",
    "spread": 50,
    "row_spacing": 60,
    "height": 45,
    "growing_degree_days": 105,
    "companions": [
        "blue-lake-bean"
    ],
    "image": "/crops/images/green-cabbage.jpg",
    "icon": "/crops/icons/green-cabbage.avif"
}